import React, { useState } from "react";
import BrandManagerShell from "./components/BrandManagerShell";
import "./brandManagerPages.css";

const TABS = [
  { id: "overview", label: "Overview" },
  { id: "by-brand", label: "By Brand" },
  { id: "by-location", label: "By Location" },
  { id: "message", label: "Message Performance" },
  { id: "song", label: "Song Performance" },
];

/**
 * Reports — production shell with intended tab navigation.
 * No fabricated KPIs, Top Brands, campaigns, or exports.
 */
export default function BrandManagerReports() {
  const [tab, setTab] = useState("overview");
  const active = TABS.find((t) => t.id === tab) || TABS[0];

  return (
    <BrandManagerShell>
      <div className="brand-manager-header">
        <h1>Reports</h1>
        <p className="subtitle">
          Brand Manager reporting across your portfolio
        </p>
      </div>

      <div
        data-testid="brand-reports-page"
        data-reports-state="unavailable"
        data-active-tab={tab}
      >
        <div className="bm-tabs" role="tablist" aria-label="Report views">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              role="tab"
              aria-selected={tab === t.id}
              className={`bm-tab${tab === t.id ? " active" : ""}`}
              data-testid={`brand-reports-tab-${t.id}`}
              onClick={() => setTab(t.id)}
            >
              {t.label}
            </button>
          ))}
        </div>

        <div className="bm-page-panel">
          <div
            className="bm-unavailable"
            data-testid="brand-reports-unavailable"
          >
            <h2>{active.label} — data not available yet</h2>
            <p>
              Reporting totals, rankings, and performance tables require the
              canonical analytics / reporting read contract. This page does
              not fabricate KPI totals, Top Brands, campaigns, charts, or
              exports.
            </p>
            <p className="bm-unavailable-note">
              Tab navigation is production chrome only until live report
              queries exist. Do not substitute Activity History, Song History,
              or Music upload history.
            </p>
          </div>
        </div>
      </div>
    </BrandManagerShell>
  );
}
